import { call, put, takeEvery } from "redux-saga/effects"
import Moment from "moment"

// Staff Redux States
import {
  GET_QUESTIONTYPES,
  GET_QUESTION_DETAIL,
  ADD_QUESTION_RESPONSE,
  GET_RESPONSE_OUTCOME,
  GET_PROJECTS,
  GET_PROJECT_DETAIL,
  GET_NNS,
  ADD_PROJECT,
  UPDATE_PROJECT,
  GET_NNS_STRANDS,
  GET_AWARD_PERIODS,
} from "./actionTypes"
import {
  getQuestionTypesSuccess,
  getQuestionTypesFail,
  getQuestionDetailSuccess,
  getQuestionDetailFail,
  addQuestionResponseSuccess,
  addQuestionResponseFail,
  getResponseOutcomeSuccess,
  getResponseOutcomeFail,
  getProjectsSuccess,
  getProjectsFail,
  getProjectDetailSuccess,
  getProjectDetailFail,
  addProjectSuccess,
  addProjectFail,
  updateProjectSuccess,
  updateProjectFail,
  getNNSSuccess,
  getNNSFail,
  getNNSStrandsSuccess,
  getNNSStrandsFail,
  getAwardPeriodsSuccess,
  getAwardPeriodsFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getQuestionTypes,
  getQuestionDetail,
  addQuestionResponse,
  getResponseOutcome,
  getProjects,
  getProjectDetail,
  addProject,
  updateProject,
  getNNSNames,
  getNNSStrands,
  getAwardPeriods,
} from "helpers/backend_helper"

function* fetchProjects() {
  try {
    const response = yield call(getProjects)
    yield put(getProjectsSuccess(response))
  } catch (error) {
    yield put(getProjectsFail(error))
  }
}

function* onAddProject({ payload: project }) {
  try {
    const response = yield call(addProject, project)
    yield put(addProjectSuccess(response))
  } catch (error) {
    yield put(addProjectFail(error))
  }
}

function* onUpdateProject({ payload: project }) {
  try {
    const response = yield call(updateProject, project)
    yield put(updateProjectSuccess(response))
  } catch (error) {
    yield put(updateProjectFail(error))
  }
}

function* fetchProjectDetail({ rowID }) {
  try {
    const response = yield call(getProjectDetail, rowID)
    let result = response

    result = {
      ...result,
      NNSs: {
        NNSID: result.NNSID,
        NNS: result.NNSName,
      },
      NNSStrands: {
        NNSStrandID: result.NNSStrandID,
        NNSStrand: result.NNSStrand ?? "Select...",
      },
      AwardPeriodIDs: {
        AwardPeriodID: result.AwardPeriodID,
        AwardPeriod: result.AwardPeriod ?? "Select...",
      },
      GranteeID: result.UserID,
      Grantees: {
        StaffID: result.UserID,
        Name: result.Grantee,
      },
      QuestionTypes: {
        QuestionTypeID: result.QuestionTypeID,
        QuestionType: result.QuestionType,
      },
      AgreedReturnDate: result.AgreedReturnDate
        ? Moment(result.AgreedReturnDate).format("DD MMM, YYYY")
        : "",
      ProjectStartDate: result.ProjectStartDate
        ? Moment(result.ProjectStartDate).format("DD MMM, YYYY")
        : "",
    }
    yield put(getProjectDetailSuccess(result))
  } catch (error) {
    yield put(getProjectDetailFail(error))
  }
}

function* fetchQuestionTypes() {
  try {
    const response = yield call(getQuestionTypes)
    yield put(getQuestionTypesSuccess(response))
  } catch (error) {
    yield put(getQuestionTypesFail(error))
  }
}

function* fetchNNSNames() {
  try {
    const response = yield call(getNNSNames)
    yield put(getNNSSuccess(response))
  } catch (error) {
    yield put(getNNSFail(error))
  }
}

function* fetchNNSStrands() {
  try {
    const response = yield call(getNNSStrands)
    yield put(getNNSStrandsSuccess(response))
  } catch (error) {
    yield put(getNNSStrandsFail(error))
  }
}

function* fetchAwardPeriods() {
  try {
    const response = yield call(getAwardPeriods)
    yield put(getAwardPeriodsSuccess(response))
  } catch (error) {
    yield put(getAwardPeriodsFail(error))
  }
}

function* fetchQuestionDetail({ rowID }) {
  try {
    const response = yield call(getQuestionDetail, rowID)
    yield put(getQuestionDetailSuccess(response))
  } catch (error) {
    yield put(getQuestionDetailFail(error))
  }
}

function* onAddQuestionResponse({ payload }) {
  try {
    const response = yield call(addQuestionResponse, payload)
    yield put(addQuestionResponseSuccess(response))
  } catch (error) {
    yield put(addQuestionResponseFail(error))
  }
}

function* fetchResponseOutcome({ payload }) {
  try {
    const response = yield call(getResponseOutcome, payload)
    yield put(getResponseOutcomeSuccess(response))
  } catch (error) {
    yield put(getResponseOutcomeFail(error))
  }
}

function* projectSaga() {
  yield takeEvery(GET_QUESTIONTYPES, fetchQuestionTypes)
  yield takeEvery(GET_QUESTION_DETAIL, fetchQuestionDetail)
  yield takeEvery(ADD_QUESTION_RESPONSE, onAddQuestionResponse)
  yield takeEvery(GET_RESPONSE_OUTCOME, fetchResponseOutcome)
  yield takeEvery(GET_PROJECTS, fetchProjects)
  yield takeEvery(GET_PROJECT_DETAIL, fetchProjectDetail)
  yield takeEvery(GET_NNS, fetchNNSNames)
  yield takeEvery(ADD_PROJECT, onAddProject)
  yield takeEvery(UPDATE_PROJECT, onUpdateProject)
  yield takeEvery(GET_NNS_STRANDS, fetchNNSStrands)
  yield takeEvery(GET_AWARD_PERIODS, fetchAwardPeriods)
}

export default projectSaga
